import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { FormattedNumber } from "../../../utils/FormattedNumber";

function CardCase({ data = {} }) {
  // safe numeric values
  const paid = Number(data?.paid_amount) || 0;
  const total = Number(data?.amount) || 0;

  // progress as percentage (paid / total) clamped to [0,100]
  const progress = total > 0 ? Math.min(Math.round((paid / total) * 100), 100) : 0;

  const cardVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    hover: { scale: 1.02 },
    tap: { scale: 0.98 }
  };

  const progressVariants = {
    initial: { width: 0 },
    animate: { width: `${progress}%` }
  };

  const staggerVariants = {
    animate: {
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 }
  };

  const { t } = useTranslation();

  return (
    <motion.div
      dir={localStorage.getItem("lang") == "ckb" || localStorage.getItem("lang") == "ar" ? "rtl" : "ltr"}
      className="w-11/12 mx-auto border-2 rounded-lg bg-white overflow-hidden"
      variants={cardVariants}
      initial="initial"
      animate="animate"
      whileHover="hover"
      whileTap="tap"
      transition={{ duration: 0.3 }}
    >
      <div className="relative overflow-hidden">
        <motion.img
          style={{ aspectRatio: "16/9" }}
          src={process.env.REACT_APP_IMG_URL + data.head_image}
          alt={data.title}
          className="w-full h-full object-cover"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
        />
      </div>

      <motion.div
        className="p-4 space-y-4"
        variants={staggerVariants}
        initial="initial"
        animate="animate"
      >
        <motion.h2
          className="text-lg font-bold text-gray-800"
          variants={itemVariants}
        >
          {data.title}
        </motion.h2>

        <motion.div variants={itemVariants}>
          <div className="flex justify-between text-sm font-medium mb-2">
            <span className="text-[#068D1F]">{progress}%</span>
          </div>

          <div
            className="w-full bg-gray-200 rounded-full h-2.5"
            role="progressbar"
            aria-valuenow={progress}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-label={t("progress")}
          >
            <motion.div
              className="bg-gradient-to-r from-[#068D1F] to-[#0EAE2C] h-2.5 rounded-full"
              variants={progressVariants}
              transition={{ type: "spring", duration: 1.5 }}
            />
          </div>
        </motion.div>

        <motion.div
          className="flex justify-between items-center"
          variants={itemVariants}
        >
          <div>
            <p className="text-xs text-gray-500">{t("paidAmount")}</p>
            <motion.p
              className="text-sm md:text-lg font-bold text-gray-800"
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2 }}
            >
              {
                data?.is_show_currency ?<FormattedNumber
                value={paid}
                locale="en-US"
                options={{ style: 'currency', currency: data?.currency?.name || 'IQD' }}

              />: paid
              }
              
            </motion.p>
          </div>

          <div>
            <p className="text-xs text-gray-500">{t("total")}</p>
            <motion.p
              className="text-sm md:text-lg font-bold text-gray-800"
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.3 }}
            >
              {
                data?.is_show_currency ?<FormattedNumber
                value={total}
                locale="en-US"
                options={{ style: 'currency', currency: data?.currency?.name || 'IQD' }}
              />: total
              }
              {/* <FormattedNumber
                value={total}
                locale="en-US"
                options={{ style: 'currency', currency: 'IQD' }}
              /> */}
            </motion.p>
          </div>
        </motion.div>
      </motion.div>
    </motion.div>
  );
}

export default CardCase;
